@import '../../styles/host.css';

:host {
    display: block;
    margin: var(--protean-input-margin, 1rem);
}

.input-wrapper {
    position: relative;
    --input-container-horizontal-padding: calc(
        0.4375rem + (var(--protean-input-border-radius, 2px) / 2)
    );
}

.input-container {
    border: 1px solid var(--protean-input-border-color);
    border-radius: var(--protean-input-border-radius, 2px);
    flex-grow: 1;
    overflow: hidden;
}

/* :host([type='color']) {
    --protean-input-border-color: transparent;
} */

:host([disabled]) .input-container {
    opacity: var(--protean-input-disabled-opacity, 0.4);
}

:host([disabled]) .input-container,
:host([disabled]) label,
:host([disabled]) input {
    cursor: not-allowed;
}

.input-container:focus-within {
    outline: auto 1px;
}

.input-container.has-error {
    border-color: var(--protean-status-error, #ab0000);
}

.error-icon {
    margin-right: 0.25rem;
    height: 1.25em;
    width: 1.25em;
}

label {
    display: flex;
    align-items: center;
    font-weight: var(--protean-input-label-font-weight, 600);
    padding: 0.375rem var(--input-container-horizontal-padding) 0.25rem;
    font-size: var(--protean-input-label-font-size, 0.75rem);
}

.optional-tag {
    font-size: var(--protean-input-label-optional-font-size, 0.75rem);
    font-weight: var(--protean-input-label-optional-font-weight, 500);
    margin-left: 0.25rem;
}

input {
    height: 30px;
    width: 100%;
    padding: 0 var(--input-container-horizontal-padding);
    border: none;
    background-color: transparent;
    font-size: var(--protean-input-font-size, 1rem);
    color: inherit;
    box-shadow: none;
    text-align: left;
}

input[type='color'] {
    display: block;
    padding: 0;
    min-width: 55px;
    cursor: pointer;
}

::-webkit-color-swatch-wrapper {
    padding: 0;
}

::-webkit-color-swatch {
    border: none;
}

::-moz-color-swatch {
    border: none;
}

:host(:not([label])) input {
    height: 55px;
}

input:focus {
    outline: none;
}

.message-container {
    position: absolute;
    top: calc(100% - 1px);
    width: 100%;
    height: 0;
    transition: height 0.2s ease-in-out;
    overflow: hidden;
    z-index: 2;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.message-container protean-message {
    margin: 0;
}

.message-container ul {
    margin: 0;
    padding: 0 1rem;
}
